import React,{useEffect} from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HomeSearch from './../components/HomeSearch.js'
import HomeCaroused from './../components/HomeCaroused.js'
import HomeImgComp from './../components/HomeImgComp.js';
import HomeCatComp from './../components/HomeCatComp.js';
import HomeExpComp from './../components/HomeExpComp.js';

// import HomeBrandComp from './../components/HomeBrandComp.js';

const Home = () => {

useEffect(()=>{
window.scrollTo(0,0)
},[])


console.log('asd=>',process.env.googleAPI)

  return (
    <div>

    <Header />
  

      <HomeImgComp/>
<section>
      <br/>
      {/* <HomeSearch/> */}
      <HomeCatComp/>

      <HomeCaroused/>
      {/* <br/> */}

      <HomeExpComp/>
      </section>
    {/* 
      <HomeBrandComp/>
     */}
      <Footer />
    </div>
  );
};

export default Home;

